module.exports = __webpack_public_path__ + "static/media/githubfinder.856b9d8b.png";